import clsx from 'clsx';
import React, { IframeHTMLAttributes } from 'react';
import styles from './Iframe.css';

const Iframe = React.forwardRef<
    HTMLIFrameElement,
    IframeHTMLAttributes<HTMLIFrameElement> & { name: string; className?: string }
>((props, ref) => {
    return <iframe ref={ref} {...props} className={clsx(styles.container, props.className)} title={props.title} />;
});

export default Iframe;
